/**
 * SF-3180 Task 2 — admin-side mirror of the sf-auth-service SSO-safe
 * user type allowlist (which itself mirrors `sf-api/controllers/
 * exchangeTokenController.js` → `VALID_USER_TYPES`).
 *
 * Source of truth: sf-auth-service `src/utils/userTypes.ts`. If that file
 * drifts we must update this one — the backend rejects any
 * `roleToType[].type` or `defaultType` not in this list with a validation
 * error.
 *
 * SF-3404 blocker fix: `super_admin` and `customer` are deliberately
 * excluded. SSO claim mappings must never promote into `super_admin` or
 * downgrade into `customer` — those transitions must go through the
 * normal admin UI, not an IdP group rule.
 *
 * Keep the display labels operator-friendly (Erol-test: a non-engineer
 * should be able to pick the right one from the dropdown).
 */

export const USER_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'area_manager', label: 'Admin' },
  { value: 'location_manager', label: 'Location Manager' },
  { value: 'employee', label: 'Employee' },
];

export const VALID_USER_TYPES: readonly string[] = USER_TYPE_OPTIONS.map((o) => o.value);

export function isValidUserType(v: unknown): v is string {
  return typeof v === 'string' && VALID_USER_TYPES.includes(v);
}
